import { createStore, applyMiddleware,combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import {userReducer} from '../redux/reducers/userReducer';
// import {listReducer,userReducer,cityReducer,menuReducer,addressReducer, parishReducer,requestReducer} from '../reducers'
const reducers = {
   user:userReducer
}

export const store = createStore( combineReducers(reducers),applyMiddleware(
   thunkMiddleware,
   //loggerMiddleware
)) ;